import { forwardRef } from 'react';
import styled from 'foundations-theming/utils';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { DragHandleIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DragHandleBar = styled.div.withConfig({
  displayName: "ResizableDragHandle__DragHandleBar",
  componentId: "sc-1sz9kvk-0"
})(["height:3px;width:100%;background-color:", ";opacity:0;"], ({
  theme
}) => theme.color['border-interactive-pressed']);
const DragHandleAffordance = styled.div.withConfig({
  displayName: "ResizableDragHandle__DragHandleAffordance",
  componentId: "sc-1sz9kvk-1"
})(["&:hover{", "{opacity:1;}}&&&{", "{", " ", "}}"], DragHandleBar, DragHandleBar, ({
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'isPreview' does not exist on type 'Pick<... Remove this comment to see the full error message
  isPreview
}) => isPreview ? 'opacity: 1' : '', ({
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'hide' does not exist on type 'Pick<Detai... Remove this comment to see the full error message
  hide
}) => hide ? 'opacity: 0' : '');
const DragHandleWrapper = styled.div.withConfig({
  displayName: "ResizableDragHandle__DragHandleWrapper",
  componentId: "sc-1sz9kvk-2"
})(["margin-top:-", ";position:absolute;width:100%;cursor:ns-resize;z-index:1;"], ({
  theme
}) => theme.space['50']);
export const ResizableDragHandle = /*#__PURE__*/forwardRef((props, ref) => {
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    // @bend-expect trellis-tokenized
    _jsx(DragHandleWrapper, Object.assign({
      ref: ref
    }, props, {
      children: /*#__PURE__*/_jsxs(DragHandleAffordance, Object.assign({}, props, {
        children: [/*#__PURE__*/_jsx(DragHandleBar, {}), /*#__PURE__*/_jsxs(Flex, {
          justifyContent: "center",
          marginBlockStart: "25",
          blockSize: "12px",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: DragHandleIcon,
            rotate: 90,
            rotateLock: true,
            paddingBlock: "0",
            paddingInline: "0",
            marginInlineEnd: "-100",
            marginInlineStart: "-50",
            size: "400"
          }), /*#__PURE__*/_jsx(IconHolder, {
            icon: DragHandleIcon,
            rotate: 90,
            rotateLock: true,
            paddingBlock: "0",
            paddingInline: "0",
            marginInlineEnd: "-100",
            marginInlineStart: "-50",
            size: "400"
          }), /*#__PURE__*/_jsx(IconHolder, {
            icon: DragHandleIcon,
            rotate: 90,
            rotateLock: true,
            paddingBlock: "0",
            paddingInline: "0",
            marginInlineEnd: "-100",
            marginInlineStart: "-50",
            size: "400"
          })]
        })]
      }))
    }))
  );
});
ResizableDragHandle.displayName = 'ReplyEditorDragHandle';
export default ResizableDragHandle;